import request from '@/common/request';

// 账户信息
export async function getInfo(params) {
	return request({ url: '/qunion/account/info', method: 'get', params });
}

// 添加账户
export async function infoAdd(data) {
	return request({ url: '/qunion/account/add', method: 'post', data });
}

// 编辑账户
export async function infoUpdate(data) {
	return request({ url: '/qunion/account/edit', method: 'post', data });
}